<template>
    <div class="row settings-page">
        <div class="col-lg-6">
            <div class="detail-section">
                <div class="section-header">Detail</div>

                <div class="detail-body row">
                    <div v-if="myAccountAvatar" class="col-md-4 user-avatar-section">
                        <div class="user-photo">
                            <img :src="myAccountAvatar" alt="User Image"/>
                        </div>
                        <button v-show="isEditMode" class="btn btn-danger"
                                @click="onRemoveMyAccountPhoto()">Delete Photo
                        </button>
                    </div>
                    <div v-else class="col-md-4 user-avatar-section">
                        <vue-dropzone
                            v-on:vdropzone-file-added="addImgUpload"
                            v-on:vdropzone-complete="completeImgUpload"
                            v-on:vdropzone-sending="sendImgUpload"
                            v-on:vdropzone-success="successImgUploadMyAccount"
                            ref="imgUploadDropMyAccount"
                            id="imgUploadDropMyAccount"
                            class="dropify-wrapper dropzoneContainer"
                            :options="myAccountDropzoneOptions"
                            :useCustomSlot="true"
                        >
                            <div class="dropify-message" style="transform: translateY(0%);">
                                <i class="bx bx-cloud-upload"></i>
                                <p class="upload-title">Upload Photo</p>
                            </div>
                        </vue-dropzone>
                    </div>

                    <div class="col-md-8 user-detail-section">
                        <div class="form-group row">
                            <h3 class="user-name">{{ currentUser.full_name }}</h3>
                        </div>
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label" for="account-status">Account Status</label>
                            <div class="col-lg-9 d-flex">
                                <label v-if="isActiveMyAccount" class="col-form-label form-text">
                                    <div class="active-icon"></div>
                                    <span class="active-user-text">Active User</span>
                                </label>
                                <label v-else class="col-form-label form-text">
                                    <div class="active-icon inactive"></div>
                                    <span class="active-user-text">Not Active User</span>
                                </label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="username_my_account"
                                   class="col-lg-3 col-form-label">Username</label>
                            <div class="col-lg-9">
                                <label
                                    v-if="!isEditMode"
                                    class="col-form-label form-text"
                                >{{ currentUser.full_name }}</label>
                                <input
                                    v-else
                                    type="text"
                                    class="form-control"
                                    v-model="currentUser.full_name"
                                    id="username_my_account"
                                />
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="first_name_my_account" class="col-lg-3 col-form-label">First
                                Name</label>
                            <div class="col-lg-9">
                                <label
                                    v-if="!isEditMode"
                                    class="col-form-label form-text"
                                >{{ currentUser.first_name }}</label>
                                <input
                                    v-else
                                    type="text"
                                    class="form-control"
                                    v-model="currentUser.first_name"
                                    id="first_name_my_account"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="last_name_my_account" class="col-lg-3 col-form-label">Last
                                Name</label>
                            <div class="col-lg-9">
                                <label
                                    v-if="!isEditMode"
                                    class="col-form-label form-text"
                                >{{ currentUser.last_name }}</label>
                                <input
                                    v-else
                                    type="text"
                                    class="form-control"
                                    v-model="currentUser.last_name"
                                    id="last_name_my_account"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">Email Address</label>
                            <div class="col-lg-9">
                                <label
                                    v-if="!isEditMode"
                                    class="col-form-label form-text"
                                >{{ currentUser.user_email }}</label>
                                <email
                                    v-else
                                    :email="currentUser.user_email"
                                    @onChange="(value) => currentUser.user_email = value"
                                    @checked="(value) => isCheckedEmail = value"
                                ></email>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="location" class="col-lg-3 col-form-label">Location</label>
                            <div class="col-lg-9">

                              <label
                                  v-if="!isEditMode"
                                  for="location_my_account"
                                  class="col-form-label form-text">
                                <template v-if="currentUser.user_address">
                                  {{ getLocation(currentUser.user_address).name }}
                                </template>
                              </label>

                              <multiselect
                                  v-else
                                  ref="repairer-user-address-options"
                                  v-model="currentUser.user_address"
                                  :options="locations"
                                  :showLabels="false"
                                  :label="'name'"
                                  :option-height="29"
                                  :max-height="203"
                                  :close-on-select="true"
                                  placeholder="Business Location"
                              />
                            </div>
                        </div>
                        <div v-if="computedIsActiveParssearchCode" class="form-group row">
                          <label for="location" class="col-lg-3 col-form-label">Partssearch Shop Location</label>
                          <div class="col-lg-9" style="padding-top: 10px;">
                            <label
                                v-if="!isEditMode"
                                class="col-form-label form-text">
                              <template>
                                <span v-if="currentUser.partssearchLocationId">
                                  {{getLocNameById(currentUser.partssearchLocationId)}}
                                </span>
                                <span v-else-if="computedDefaultPSLocId && !currentUser.partssearchLocationId">
                                  Default {{getLocNameById(computedDefaultPSLocId)}}
                                </span>
                              </template>
                            </label>
                            <template v-else>
                              <multiselect
                                  v-if="computedIsSetDefaultPSLoc"
                                  v-model="computedPSLocation"
                                  :options="locationsOptions"
                                  :showLabels="false"
                                  :option-height="29"
                                  :max-height="203"
                                  placeholder="Partssearch Shop Location"
                                  :close-on-select="true"
                                  track-by="id"
                                  label="name"
                              />
                              <span v-else>None</span>
                            </template>
                          </div>
                        </div>
                        <div class="form-group row">
                            <label for="work_phone" class="col-lg-3 col-form-label">Work Phone</label>
                            <div class="col-lg-9">
                                <label
                                    v-if="!isEditMode"
                                    for="work_phone_my_account"
                                    class="col-form-label form-text"
                                >{{ currentUser.work_phone }}</label>
                                <input
                                    v-else
                                    type="text"
                                    class="form-control"
                                    v-model="currentUser.work_phone"
                                    id="work_phone_my_account"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="mobile_phone_my_account" class="col-lg-3 col-form-label">Mobile
                                Phone</label>
                            <div class="col-lg-9">
                                <label
                                    v-if="!isEditMode"
                                    for="mobile_phone"
                                    class="col-form-label form-text"
                                >{{ currentUser.mobile_phone }}</label>
                                <input
                                    v-else
                                    type="text"
                                    class="form-control"
                                    v-model="currentUser.mobile_phone"
                                    id="mobile_phone_my_account"
                                />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">Role</label>
                            <div class="col-lg-9">
                                <label
                                    class="col-form-label form-text"
                                >{{ currentUser.roleValue.label }}
                                </label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">Last Logged In</label>
                            <div class="col-lg-9">
                                <label class="col-form-label form-text">{{ currentUser.lastLoggedIn }}</label>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-lg-3 col-form-label">Active sessions</label>
                            <div class="col-lg-9">
                                <label class="col-form-label form-text">{{ currentUser.activeSessions }}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="detail-footer">
                    <div class="form-group w-auto action-btns d-flex justify-content-center m-auto">


                        <button class="edit-btn float-right" v-if="isEditMode" @click="onCancelEditAccount()">
                            Cancel
                        </button>
                        <button class="update-btn float-right" v-if="isEditMode" @click="onUpdateMyAccountInfo()">
                            Update
                        </button>
                        <button v-if="!isEditMode"
                                class="close-active-btn float-right"
                                @click="onCloseActiveSessionsMyAccount()"
                        >Close Active Sessions
                        </button>
                        <button class="update-btn float-right" v-if="!isEditMode" @click="onEditAccount()">Edit
                        </button>
                    </div>
                </div>
            </div>

            <div class="update-password-section">
                <div class="section-header">Password</div>

                <div class="form-body">
                    <div class="form-group row mt-3">
                        <label class="col-lg-4 col-form-label" for="password_my_account">Current
                            Password</label>
                        <div class="col-lg-8">
                            <input
                                type="password"
                                class="form-control"
                                v-model="currentPassword"
                                id="password_my_account"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-lg-4 col-form-label"
                               for="new_password__my_account">Password</label>
                        <div class="col-lg-8">
                            <input
                                type="password"
                                class="form-control"
                                v-model="newPassword"
                                id="new_password_my_account"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="confirm_password_of_my_account" class="col-lg-4 col-form-label">Confirm
                            Password</label>
                        <div class="col-lg-8">
                            <input
                                type="password"
                                class="form-control"
                                v-model="confirmPassword"
                                id="confirm_password_of_my_account"
                            />
                        </div>
                    </div>

                    <div class="form-group row action-btns justify-content-end">
                        <button class="update-btn float-right" @click="onUpdatePasswordMyAccount()">Update</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import  Email from '../utility/email-validator';
import Multiselect from 'vue-multiselect';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vueDropzone from "vue2-dropzone";
import _ from "lodash";
import Axios from "axios";
import {appConfig} from '../../config.js';

export default {
    name: 'MyAccount',
    components: {
        Multiselect,
        vueDropzone,
        Email,
    },
    props: {
      isActiveParssearchCode: {
        type: Boolean,
        default: false,
      },
      isSetDefaultPSLoc: {
        type: Boolean,
        default: false,
      },
      defaultPSLocId: {
        type: String,
        default: null,
      },
    },
    data() {
        return {
            isCheckedEmail: true,
            currentUser: {
                id: 0,
                activeSessions: 0,
                businessName: '',
                firstName: '',
                fullName: '',
                groupId: 0,
                internalEmail: '',
                jobTitle: '',
                lastLoggedIn: '',
                lastName: '',
                mobilePhone: '',
                profilePicture: '',
                address: '',
                email: '',
                vendorEmail: '',
                vendorId: 0,
                vendorLocation: '',
                vendorPhone: '',
                website: '',
                workPhone: '',
                partssearchLocationId: '',
                roleValue: {}
            },
            selectedBrand: '',
            myAccountAvatar: '',
            companyRole: '',
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            isEditMode: false,
            isActiveMyAccount: true,
            locations: [],
            currentUserLocation: '',
            myAccountDropzoneOptions: {
                headers: {Authorization: localStorage.getItem('token')},
                resizeWidth: 400,
                resizeQuality: 0.7,
                url: appConfig.baseAPIURL + '/fe/user/photo/upload',
                method: 'post',
                maxFilesize: 5,
                thumbnailWidth: 160,
                thumbnailHeight: 160,
                addRemoveLinks: false,
                forceFallback: false,
                autoProcessQueue: true,
                acceptedFiles: 'image/jpeg, image/jpg, image/png',
                dictFileTooBig:
                    'Your file has exceeded the maximum limit of 5MB per file. Please reduce the file size and upload again'
            },
            integrationsPS: [],
        }
    },
    mounted() {
        this.loadIntegrations();
        if (!_.isEmpty(this.userInfo)) {
            this.setCurrentUser(this.userInfo);
        }
        this.loadLocations();
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            roles: 'roles',
            getterPartsSearchLocations: 'getPartsSearchLocations',
            isShopManagerUser: 'isShopManagerUser'
        }),
        computedIsActiveParssearchCode() {
          if (this.isShopManagerUser) {
            return this.isActiveParssearchCode
          }
          return !!(this.integrationsPS && this.integrationsPS.api_key && this.integrationsPS.enabled);
        },
        computedIsSetDefaultPSLoc() {
          if (this.isShopManagerUser) {
            return this.isSetDefaultPSLoc
          }
          return !!(this.integrationsPS && this.integrationsPS.partssearchDefaultLocation);
        },
        computedDefaultPSLocId() {
          if (this.isShopManagerUser) {
            return this.defaultPSLocId
          }
          return this.integrationsPS.partssearchDefaultLocation;
        },
        locationsOptions() {
          if (!this.getterPartsSearchLocations) {
            return  []
          }
          let locations = this.getterPartsSearchLocations.slice();
          locations.unshift({name: 'Default', id: null});
          return locations;
        },
        computedPSLocation: {
          get: function () {
            let vm = this;
            try {
              let item = _.find(this.locationsOptions, function (itm) {
                return Number(itm.id) === Number(vm.currentUser.partssearchLocationId);
              });
              return item;
            } catch (e) {
              return {};
            }
          },
          set: function (item) {
            if (item) {
              this.currentUser.partssearchLocationId = item.id;
            }
          }
        },
    },
    methods: {
        ...mapActions({
            loadUserInfo: 'loadUserInfo'
        }),
        loadIntegrations() {
          Axios.get('/fe/vendor/get-integrations')
            .then((res) => {
              if (res.data && res.data._status) {
                this.integrationsPS = res.data.partssearch;
              }
            })
            .catch(() => {

            });
        },
        getLocNameById(id) {
          let loc = _.find(this.locationsOptions, (lc) => {
            return Number(lc.id) === Number(id)
          })
          if (loc) {
            return loc.name;
          } else {
            return  '';
          }
        },
        loadLocations() {
          Axios.get('/fe/vendor/locations')
              .then(res => {
                if(res && res.data && res.data._status){
                  this.locations = res.data.locations;
                }
              })
              .catch(e => toastr.error(e))
        },
        getLocation(id){
          let data = _.find(this.locations, (item) => {
            return id === item.id;
          });
          if (_.isEmpty(data)) {
            return {name: ''};
          }
          return data;
        },
        onEditAccount: function () {
          if (!_.isEmpty(this.currentUser.user_address)) {
            let address = _.find(this.locations, (location) => {
              return this.currentUser.user_address == location.id;
            });
            this.currentUser.user_address = address;
          }
            this.isEditMode = true;
        },
        onCancelEditAccount: function () {
            this.isEditMode = false;
        },
        onCloseActiveSessionsMyAccount: function () {
            this.isEditMode = false;
            NProgress.start();
            Axios.post('/fe/user/closeActiveSessions', {
                data: this.currentUser,
                profile_image: ''
            }).then(response => {
                toastr.success('Active sessions are closed successfully');
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.push('/login')
                    });
            }).catch(error => {
                toastr.error(error);
            }).finally(()=>{
                NProgress.done();
            });
        },
        onRemoveMyAccountPhoto: function () {
            NProgress.start();
            Axios.post('/fe/user/photo/delete').then(response => {
                toastr.success('User photo has been removed');
                this.myAccountAvatar = '';
                this.loadUserInfo();
            }).catch(error => {
                toastr.error('User photo has not been removed');
            }).finally(()=>{
                NProgress.done();
            });
            this.isEditMode = false;
        },
        onUpdateMyAccountInfo: function () {
            if (!this.isCheckedEmail) {
              toastr.error('Please enter a valid email address');
              return;
            }
            if (this.currentUser.user_address && this.currentUser.user_address.id) {
              this.currentUser.user_address = this.currentUser.user_address.id;
            }
            NProgress.start();
            Axios.post('/fe/user/info', {
                data: this.currentUser,
                profile_image: ''
            }).then(response => {
                NProgress.done();
                toastr.success(response.data.msg);
            }).catch(error => {
                NProgress.done();
                toastr.error(error);
            });
            this.isEditMode = false;
        },
        onUpdatePasswordMyAccount: function () {
            NProgress.start();
            Axios({
                method: 'post',
                responseType: 'json',
                url: '/fe/user/pwd',
                validateStatus: function (status) {
                    return status < 500
                },
                data: JSON.stringify({
                    password: this.currentPassword,
                    new_password: this.newPassword,
                    confirm_new_password: this.confirmPassword
                })
            }).then(response => {
                NProgress.done()
                if (response.status == 200) {
                    toastr.success(response.data.msg);
                } else {
                    toastr.error(response.data.msg);
                }
            }).catch((error) => {
                NProgress.done()
                toastr.error(error)
            });
        },
        onUnLockPasswordMyAccount: function () {
        },
        //Images
        addImgUpload($event) {
            $event.previewElement.children[
            $event.previewElement.children.length - 1
                ].style.display = "none";
        },
        completeImgUpload($event) {
            $event.previewElement.children[
            $event.previewElement.children.length - 1
                ].removeAttribute("style");
        },
        sendImgUpload($event) {
            $event.previewElement.children[
            $event.previewElement.children.length - 1
                ].style.display = "none";
        },
        successImgUploadMyAccount(file, response) {
            if (response.status) {
                this.myAccountAvatar = file.dataURL;
                this.currentUser.avatarFileId = response.photoId;
                this.onUpdateMyAccountInfo();
                this.loadUserInfo();
            } else {
                var vm = this;
                setTimeout(function () {
                    vm.$refs.imgUploadDropMyAccount.removeFile(file);
                }, 1000);
            }
        },
        setCurrentUser(val) {
            this.currentUser = Object.assign({}, val);
            this.currentUser.roleValue = _.find(this.roles, role => {
                return role.id === Number(val.group_id)
            });
            this.myAccountAvatar = val.avatar;
        },
        onSelectGroup(selectedOption, id) {
            this.currentUser.group_id = selectedOption.id;
        }
    },
    watch: {
        userInfo: {
            handler: function (val) {
                this.setCurrentUser(val);
            },
            deep: true
        }
    }
}
</script>

<style>
.settings-page-users .btn-edit {
    background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTkgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2MiAoMTAxMDEwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5BQkU0Q0UxRi0yMDAyLTQ2QTEtQTVBMS0yRTUwMDg0MDQ5MTE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IlVJLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkRhc2hib2FyZC1SZWRlc2lnbi0oVmlldy1Bc3Nlc29ycykiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzc1LjAwMDAwMCwgLTEwMDYuMDAwMDAwKSIgZmlsbD0iIzFCMUUzOCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IlJvdy0wMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY1LjAwMDAwMCwgMTAwNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJwZW5jaWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTAuMDAwMDAwLCAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi4yMzgsNS40NzIgTDMuMiwxNC41MSBMMi42MDksMTYuNTI2IEw0LjU4NCwxNS45NTUgTDEzLjY1Miw2Ljg4NyBMMTIuMjM4LDUuNDcyIFogTTEzLjc4LDMuOTMgTDE1LjE5NCw1LjM0NCBMMTYuNTEyLDQuMDI2IEMxNi43MDcxOTEsMy44MzA3NTAwNyAxNi43MDcxOTEsMy41MTQyNDk5MyAxNi41MTIsMy4zMTkgTDE1LjgwNCwyLjYxMiBDMTUuNjA4NzUwMSwyLjQxNjgwOTAzIDE1LjI5MjI0OTksMi40MTY4MDkwMyAxNS4wOTcsMi42MTIgTDEzLjc4MSwzLjkzIEwxMy43OCwzLjkzIFogTTE3LjIxOSwxLjE5OCBMMTcuOTI2LDEuOTA1IEMxOC45MDE5NTQ4LDIuODgxMjQ5NjMgMTguOTAxOTU0OCw0LjQ2Mzc1MDM3IDE3LjkyNiw1LjQ0IEw1LjYzNCwxNy43MzMgTDEuNDE0LDE4Ljk1MyBDMS4wNjM2NjE3LDE5LjA1NDAxMiAwLjY4NjExMjg5NCwxOC45NTYzNDA0IDAuNDI4NzExMjksMTguNjk4MTA2NSBDMC4xNzEzMDk2ODYsMTguNDM5ODcyNSAwLjA3NDg1NzQ1MiwxOC4wNjIwMTA0IDAuMTc3LDE3LjcxMiBMMS40MjUsMTMuNDU3IEwxMy42ODUsMS4xOTcgQzE0LjY2MTI0OTYsMC4yMjEwNDUxNTQgMTYuMjQzNzUwNCwwLjIyMTA0NTE1NCAxNy4yMiwxLjE5NyBMMTcuMjE5LDEuMTk4IFoiIGlkPSJTaGFwZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=") no-repeat top left !important;
    border: none;
    width: 36px;
    height: 20px;
}

.settings-page-users .btn-trush {
    background: url("data:image/svg+xml;base64,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") no-repeat center left !important;
    border: none;
    width: 36px;
    height: 20px;
}

.settings-page-users .edit-btn {
    height: 31px;
    width: 101px;
    border: 1px solid rgba(28, 31, 57, 0.25) !important;

}

.settings-page-users .update-btn {
    width: 100px;
    height: 31px;
    border: none;
    background-color: #5E79FF !important;
    color: #ffffff;
}

.settings-page-users .bx-cloud-upload {
    font-size: 37px !important;
    color: #5E79FF;
}

.settings-page-users .unlock-btn {
    height: 31px;
    width: 101px;
    border: 1px solid rgba(28, 31, 57, 0.25) !important;
    border-radius: 3px;
    background: none;
    font-size: 13px;
    font-weight: bold;
}

.settings-page-users .action-btns {
    height: 30px;
    padding: 6px;
    justify-content: flex-end;
}

.settings-page-users .action-btns button {
    border-radius: 3px;
    font-size: 13px;
    font-weight: bold;
    background: none;
    margin-left: 5px;
    margin-right: 5px;
}

.settings-page-users .table-header {
    border: none !important;
    height: 48px;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 18px;
}

.settings-page-users .table-responsive {
    border-radius: 3px;
    background-color: rgba(27, 30, 56, 0.1);
    overflow-x: initial !important;
}

.settings-page-users .tab-content-table {
    padding-top: 12px;
}

.settings-page-users .table td {
    border-bottom: 1px solid #dee2e6 !important;
}

.settings-page-users .table td.name, .settings-page-users .table td.role {
    font-family: "Nunito Sans" !important;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
}

.settings-page-users .table td.role {
    font-size: 12px;
}

.settings-page-users .table-header {
    font-size: 13px;
    font-weight: bold;
    border: none !important;
    vertical-align: middle !important;
}

.settings-page-users .table-body {
    font-size: 12px;
    font-weight: 600;
}

.settings-page-users .close-active-btn {
    height: 31px;
    width: 152px;
    border: 1px solid rgba(28, 31, 57, 0.25) !important;
    color: #1c1f39;
    border-radius: 3px !important;
    font-family: "Nunito Sans";
    background: none;
    font-weight: bold;
}

.settings-page-users .delete-user {
    height: 31px;
    width: 101px;
    border: 1px solid #ff5e5e !important;
    border-radius: 3px !important;
    color: #ff5e5e;
    background: none;
    font-family: "Nunito Sans";
    font-size: 13px;
    font-weight: bold;
}

.settings-page-users .update-password-section {
    margin-top: 15px;
    margin-bottom: 15px;
    border: 1px solid rgba(27, 30, 56, 0.25);
    border-radius: 3px;
}

.settings-page-users .detail-section {
    border: 1px solid rgba(27, 30, 56, 0.25);
    border-radius: 3px;
}

.settings-page-users .section-header {
    padding: 1rem;
    font-size: 13px;
    font-weight: bold;
    border-bottom: 1px solid rgba(27, 30, 56, 0.25);
}

.settings-page-users .detail-body {
    padding: 1rem;
}

.settings-page-users .user-photo {
    text-align: center;
}

.settings-page-users .user-photo img {
    height: 164px;
    width: auto;
    border-radius: 3px;
}

.settings-page-users .user-avatar-section {
    padding-left: 0 !important;
}

.settings-page-users .user-avatar-section button {
    width: 100%;
    border-radius: 3px;
    color: #ffffff;
    font-size: 13px;
    font-weight: bold;
    background-color: #ff5e5e !important;
    margin-top: 10px;
}

.settings-page-users .user-name {
    margin-top: 6px;
    font-size: 21px;
    font-weight: bold;
}

.settings-page-users .active-user-text {
    margin-left: 12px;
}

.settings-page-users .user-detail-section {
    padding: 0 !important;
}

.settings-page-users .user-detail-section .col-form-label {
    padding-left: 6px !important;
}

.settings-page-users .user-detail-section .form-text {
    margin: 0;
    font-size: 12px;
    font-weight: 600;
}


.settings-page-users .table td {
    border-bottom: 1px solid #dee2e6 !important;
}

.settings-page-users .table td.name {
    font-size: 12px;
    font-weight: bold;
}

.settings-page-users .table td.role {
    font-size: 12px;
}

.settings-page-users .drop-down-text {
    color: #1c1f39;
    font-size: 13px;
    font-weight: 700;
}

.settings-page-users .business-details .col-md-5 {
    padding-left: 0;
}


.settings-page-users .active-icon {
    height: 8px;
    width: 8px;
    background-color: #2dca73;
    border-radius: 50%;
    position: absolute;
    margin-top: 4px;
}

.settings-page-users .active-icon.inactive {
    background-color: lightgray;
}

.settings-page-users .edit-active-icon {
    margin-top: 9px;
}

.settings-page-users .active-user-text {
    margin-left: 12px;
}

.settings-page-users .edit-active-icon {
    margin-top: 9px;
}

.settings-page-users .text-active {
    top: -3px;
    position: relative;
}
</style>
<style scoped>
    .multiselect__option {
        height: 40px;
    }
    </style>
